import { render, staticRenderFns } from "./LessonEdit.vue?vue&type=template&id=0150d32d&scoped=true&"
import script from "./LessonEdit.vue?vue&type=script&lang=js&"
export * from "./LessonEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0150d32d",
  null
  
)

export default component.exports